import { render } from "./Statutes.vue?vue&type=template&id=45561bcb&scoped=true"
import script from "./Statutes.vue?vue&type=script&lang=js"
export * from "./Statutes.vue?vue&type=script&lang=js"

import "./Statutes.vue?vue&type=style&index=0&id=45561bcb&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45561bcb"]])

export default __exports__